<div class="page-container">

  <!-- SOLDE TOTAL -->
  <div class="total-balance-card">
    <span class="label">Solde total disponible</span>
    <span class="amount">{{ sum | number:'1.0-0' }} XOF</span>
  </div>

  <!-- TITRES -->
  <h3 class="montir">Montant par titres</h3>

  <div class="titles-grid">
    <div class="title-card" *ngFor="let item of data">

      <!-- Date -->
      <span class="date">
        {{ item.date | date: 'dd/MM/yyyy' }}
      </span>

      <!-- Infos -->
      <div class="title-info">

        <div class="text-info">
          <div class="titre">{{ item.ticket }}</div>
          <div class="solde">Solde disponible</div>
        </div>
      </div>

      <!-- Footer avec montant et bouton -->
      <div class="card-footer">
        <span class="amount-small">
          {{ item.amount | number:'1.0-0' }} XOF
        </span>

        <button class="btn" (click)="showDetails(item)">
          Détails >
        </button>
      </div>

    </div>
  </div>

</div>